var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.finishAmendMode && _vm.done
        ? [
            _vm.isAmendV && _vm.editOrderMode == 1
              ? _c("CustomerCacheNew", {
                  on: { updateRouterStatus: _vm.updateRouterStatus }
                })
              : _c("customer-cache", {
                  on: { updateRouterStatus: _vm.updateRouterStatus }
                })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82a46352", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82a46352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/customer.vue
// module id = LKIv
// module chunks = 2